import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import styled, { withTheme } from 'styled-components'
import { message, Modal, Popconfirm } from 'antd'

import { CardContainer } from '../Reusable/CardContainer'
import { Flex, FlexColumn } from '../../Reusable/Container'
import environment from '../../../environment'
import AppIcon from '../../../Images/product-menu/approvals-menu-icon-active.png'
import { apiPOSTReq, trackEvent } from '../../../Utils/api'
import CardHeader from '../Reusable/CardHeader'
import LucideIcon, { TextButton } from '../../Reusable/Button'
import { Image } from '../../Reusable/Image'
import ArrowRight from "../../../Images/arrow-right.png"
import ModalClose from '../../../Images/modal-close.png'
import { Tag, Text } from '../../Reusable/Text'
import { getDateInLocalTZ, getResourcePerm } from '../../../Utils/util'
import TableView from '../../Reusable/TableView'
import hexToRgba from 'hex-to-rgba'
import moment from 'moment'
import { ScrollableTableView } from '../Reusable/ScrollableTableView'
import ApprovalDetail from '../../Reusable/ApprovalDetail'
import { ErrorAlert } from '../../Reusable/Alert'
import { LoadingOutlined } from '@ant-design/icons'
import { approvalsInbox } from '../Utils/EmptyStateData'
import OverlayContainer from '../Reusable/OverlayContainer'
import { CircleCheckBig } from 'lucide-react'

import AbstractArt from "../../../Images/dash-banking.svg"

class Approvals extends Component {
    state = {
        loading: true,
        todoApprovals: [],
        emptyStateCard: false,
        emptyStateData: approvalsInbox
    }

    componentDidMount() {
        this.fetchInbox()
        this.getBBRules()
    }

    fetchInbox = () => {
        const { UserInfo } = this.props.store

        const body = { "approverUserId": UserInfo.Email, "sortDirection": "DESC", size: 25, page: 0 }

        this.setState({ loading: true })
        apiPOSTReq(`${environment.bbBaseUrl}/bb/approvals/getInboxItems`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                this.setState({ loading: false })
                const data = resp || {}

                if (data.result) {
                    if (err) throw new Error(err)
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
                this.fetchPayablesInbox(data.pendingItemList || [])
            } catch (error) {
                console.log("ERRR getAccounts", error, err, resp)
            }
        })
    }

    fetchPayablesInbox = (bankingItems) => {
        const { UserInfo } = this.props.store
        const body = { "approverUserId": UserInfo.Email, "sortDirection": "DESC", size: 25, page: 0 }

        apiPOSTReq(`${environment.payBaseUrl}/payables/approvals/getInboxItems`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                this.setState({ loading: false })
                const data = resp || {}

                if (data.result) {
                    if (err) throw new Error(err)
                    this.setState({ todoPayApprovals: (bankingItems || []).concat(data.pendingItemList) })
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR getAccounts", error, err, resp)
            }
        })
    }

    getBBRules = () => {
        apiPOSTReq(`${environment.bbBaseUrl}/bb/approvals/getActiveApprovalRules`, null, { "RuleTypes": ["ACH", "Wire", "Recipient", "Payment"] }, (err, resp) => {
            try {
                const data = resp || {}
                if (data.result) {
                    if (err) throw new Error(err)
                    this.getPayRules(data.approvalRuleList || [])
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR getActiveApprovalRules", error, err, resp)
            }
        })
    }

    getPayRules = (bbRules) => {
        apiPOSTReq(`${environment.payBaseUrl}/payables/approvals/getActivePayablesApprovalRules`, { "BankProvider": environment.bankProvider.crb }, { "RuleTypes": ["Payable"] }, (err, resp) => {
            try {
                const data = resp || {}
                if (data.result) {
                    if (err) throw new Error(err)
                    var rules = bbRules.concat(data.approvalRuleList || [])
                    this.setState({ emptyStateCard: (rules.length == 0) })
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR getRules", error, err, resp)
            }
        })
    }

    handleApprove = (selectedApproval) => {
        this.setState({ reasonError: false, loadingApprove: selectedApproval.objectId })
        const { UserInfo } = this.props.store
        var username = UserInfo.Email
        var request = {
            "approverUserId": username,
            "InstanceId": selectedApproval.ruleInstanceId,
            "objectId": selectedApproval.objectId,
            "objectType": selectedApproval.objectType,
            "UserAction": "Approved",
            "reason": null
        }
        var approveUrl = `${environment.bbBaseUrl}/bb/approvals/approve`
        if (selectedApproval.sourceApplication == "Payables") {
            approveUrl = `${environment.payBaseUrl}/payables/approvals/approve`
        }
        trackEvent({ name: "dashboard_cta", property: `approve` });
        apiPOSTReq(approveUrl, { "BankProvider": environment.bankProvider.crb }, request, (err, resp) => {
            this.setState({ loadingApprove: null })
            try {
                if (err) throw new Error(err)
                const data = resp || {}
                if (data.result) {
                    message.success('Approval successful!')
                    this.fetchInbox()
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                ErrorAlert({ description: error.message })
            }
        })
    }

    columns = [
        {
            title: 'Description',
            dataIndex: 'contextIdentifier',
            key: 'contextIdentifier',
            render: (contextIdentifier, item) => {
                return (
                    <FlexColumn start gap='2px'>
                        <Text title={contextIdentifier}>{contextIdentifier}</Text>
                        <Text size={'12px'} height={'14px'} weight={500} color={hexToRgba(this.props.theme.colors.primary2, 0.5)}>{getDateInLocalTZ(item.assignedTime)}</Text>
                    </FlexColumn>
                )
            },
        },
        {
            title: 'Requested By',
            dataIndex: 'initiatedBy',
            align: 'right',
            key: 'initiatedBy',
            render: (initiatedBy, item) => {
                var source = item.sourceApplication
                var otTag = item.objectType
                if (item.objectType === "Counterparty") otTag = "New Recipient"
                var aType
                if(source === 'Payables') {
                    aType = 'Bill Payment'
                } else {
                    if(item.objectType === "Counterparty") aType = otTag
                    else aType = `${item.objectType} Payment`
                }
                return (
                        <div className='cell-content'>
                            <Flex end centerH gap='4px'>
                                <span className='hide-on-hover' style={{ fontWeight: 500, fontSize: '14px' }} title={otTag}>{aType}</span>
                                {(this.state.loadingApprove == item.objectId) && <LoadingOutlined style={{ fontSize: 14 }} spin />}
                            </Flex>
                            
                            <Popconfirm 
                                title={`Are you sure you want to approve this ${aType}`} 
                                okText='Yes' 
                                onClick={(e) => e.stopPropagation()} 
                                onConfirm={(e) => { 
                                                e.stopPropagation()
                                                this.handleApprove(item)
                                            }} 
                                onCancel={(e) => { e.stopPropagation() }}
                            >
                                <TextButton
                                    className='show-on-hover'
                                    title='Quick approve'
                                    text='APPROVE'
                                />
                            </Popconfirm>
                        </div>
                    )
            },
            width: '140px'
        }
    ]
    
    render() {
        var { todoPayApprovals, loading, showApprovalModal, approvalRecord, emptyStateCard, emptyStateData } = this.state
        var { theme } =  this.props

        todoPayApprovals = (todoPayApprovals || []).sort((a, b) => (moment(b.assignedTime).toDate() - moment(a.assignedTime).toDate()))

        const paymentsPerm = getResourcePerm("BusinessBanking.Payments")
        const billPaymentsPerm = getResourcePerm("Payables.Bill Payments")
        const recipientsPerm = getResourcePerm("BusinessBanking.Recipients")
        var approvalsEnabled = (paymentsPerm.approve || recipientsPerm.approve || billPaymentsPerm.approve)

        if(!emptyStateCard)
            return (
                <>
                    <CardContainer small>
                        <FlexColumn>
                            <CardHeader 
                                imgSrc={AppIcon}
                                titleText='Approvals' 
                                desc='Pending approvals'
                                path='approvals/pending'
                                secondaryContent={
                                    <FlexColumn centerVertically>
                                        {<TextButton 
                                            onClick={() => {
                                                trackEvent({ name: "dashboard_cta", property: `view pending` });
                                                this.props.history.push('approvals/pending');
                                            }} 
                                            rightIcon={<Image src={ArrowRight} />} text="VIEW PENDING" />}
                                    </FlexColumn>
                                }
                            />
                            <ScrollableTableView
                                id="approvals"
                                columns={this.columns}
                                dataSource={todoPayApprovals}
                                rowKey='objectId'
                                loading={loading}
                                borderView
                                hideHeader
                                scroll={{ y: 275 }} // Enable vertical scrolling
                                pagination={false}
                                onRow={(record, rowIndex) => {
                                    return {
                                        onClick: event => {
                                            this.setState({ showApprovalModal: true, approvalRecord: record })
                                        }, // click row
                                    }
                                }}
                            />
                        </FlexColumn>
                    </CardContainer>
                    <Modal
                        visible={showApprovalModal}
                        footer={null}
                        closable={true}
                        width={((approvalRecord || {}).sourceApplication === 'Payables') ? 1250 : 700}
                        destroyOnClose={true}
                        onCancel={() => {
                            this.setState({ showApprovalModal: false })
                        }}
                        closeIcon={<img width='24px' height='24px' src={ModalClose} />}
                        top='20px'
                    >
                        <ApprovalDetail 
                            selectedApproval={approvalRecord}
                            onSubmit={() => {                                
                                this.setState({ showApprovalModal: false })
                                this.fetchInbox()
                            }}
                            onApprovalAction={() => this.props.onApprovalAction ? this.props.onApprovalAction() : {}}
                            type={((approvalRecord || {}).sourceApplication === 'Payables') ? 'Bill Payments' : 'Banking'}
                        />
                    </Modal >
                </>
            )
        else
            return (
                <CardContainer small>
                    <OverlayContainer 
                        // fadeDirection="bottom"
                        small
                        radial
                        message={
                            <FlexColumn center gap='8px'>
                                <LucideIcon icon={CircleCheckBig} color={theme.colors.primary} size={24} />
                                <Text heading weight={600}>Easy controls</Text>
                                <Text center>Create rules and simplify your approval processes.</Text>
                                {approvalsEnabled && <TextButton 
                                                        onClick={() => {
                                                            trackEvent({ name: "dashboard_cta", property: `setup rule` });
                                                            this.props.history.push('banking/controls');
                                                        }} 
                                                        rightIcon={<Image src={ArrowRight} />} text="SETUP RULE" />}
                                {!approvalsEnabled && <Text center color={theme.colors.primary2}>Contact Aion to enable feature</Text>}
                            </FlexColumn>
                        }
                    >
                        <FlexColumn start grow>
                            <CardHeader 
                                imgSrc={AppIcon}
                                titleText='Approvals' 
                                desc='Pending approvals'
                                path='approvals/pending'
                                
                            />
                            <ScrollableTableView
                                id="approvals"
                                columns={this.columns}
                                dataSource={emptyStateData}
                                rowKey='inboxId'
                                borderView
                                hideHeader
                                scroll={{ y: 275 }} // Enable vertical scrolling
                                pagination={false}
                            />
                        </FlexColumn>
                    </OverlayContainer>
                </CardContainer>
            )
    }
}

function mapStateToProps(state) {
    return {
        store: state.aionAppReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(Approvals)))